const steps = ["frequency", "segment", "notification", "review"];

export default steps;



// WEBPACK FOOTER //
// ./src/state/steps.js